import { render, staticRenderFns } from "./LoadBalancer.vue?vue&type=template&id=aa23ed1e&"
import script from "./LoadBalancer.vue?vue&type=script&lang=js&"
export * from "./LoadBalancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports